<template lang="pug">
.content.sites-list-setting
    setting-title(
        title="站点管理",
        description="只有在本列表中的站点才会被统计。请准确添加站点和统计代码"
    )
        .btn.btn-primary.pull-right.add-site.btn-big(@click="openSiteNew", v-show="domainList.length > 0")
            | 添加新站点

    .sites-list(v-flowgrid="4", v-show="domainList.length > 0")
        li(v-for="(item, $index) in domainList")
            .site-item
                .top
                    a(@click="goToReport(item.id)")
                        h2(:title="item.domainTitle || item.domain")
                            | {{item.domainTitle || item.domain}}
                    span.opt
                        a(@click="openCodePopup(item)", title="获取代码")
                            | 获取代码
                        a.edit(@click="openSiteEdit(item, $index)", title="修改")
                            i.fa.fa-edit.fa-lg
                        a.delete(@click="openDeleteSite(item, $index)", title="删除")
                            i.fa.fa-trash-o.fa-lg
                .desc
                    h3(v-show="item.industry_1 && item.industry_2")
                        | {{item.industryText}}
                    p
                        | 生效时间：{{item.effecttime}}
                dl(v-if="item.subDomain.length>0")
                    dt
                        | 其他域名 (共{{item.subDomain.length}}个)
                    dd(v-for="(sub, index) in item.subDomain")
                        span.index
                            | {{index + 1}}.{{sub}}
    
    .zone.content-part.iframe-header(v-show="domainList.length === 0")
        TableTitle(slot="icon", icon="fa fa-bolt", title="新建站点")
        .header-chart-line
        v-form(v-model="activeSite", :before-submit="preventSubmit", ref="newSite")
            v-form-item(label="站点名称")
                v-input(v-model="activeSite.domainTitle", :rules="rules.title", placeholder="请输入1-50字符名称")
            .item
                .label 站点分类：
                .control
                    select.industry(
                        :class="{error: industrySelectionsDirty && industryErrors[0]}"
                        v-model="activeSite.industry_1",
                        @change="resetSubIndustry"
                    )
                        option(
                            v-for="item in industryMainList",
                            :value="item.id",
                            :key="item.id"
                        ) {{item.name}}
                    select.sub-industry(
                        v-model="activeSite.industry_2",
                        :class="{error: industrySelectionsDirty && industryErrors[1]}",
                        @change="industrySelectionsDirty = true"
                    )
                        option(
                            v-for="item in industrySubList",
                            :value="item.id",
                            :key="item.id"
                        ) {{item.name}}

                    em.error(v-show="industrySelectionsDirty && (industryErrors[0] || industryErrors[1])") 请选择分类
            .item
                .label 主域名：
                .control 
                    v-input(v-model="activeSite.domain", :rules="rules.domain", @input="onDomainInput", placeholder="请输入域名如 aaa.com, 300 字符以内")

            .item(v-for="(item, index) in activeSite.subDomain", :key="index")
                .label 域名 {{index + 1}}：
                .control
                    v-input(
                        v-model="activeSite.subDomain[index]",
                        :rules="rules.subDomain",
                        ref="subdomain",
                        placeholder="请输入域名，不建议输入带path的URL"
                    )
                    a(@click="removeSubDomain(index)") 
                      i.fa.fa-trash
            .item(v-show="activeSite.subDomain.length > 0")
                .label
                .control 
                  span.note-text （注：添加其他域名需与主域名不同，实现跨域监测数据）
            .item
                .label
                .btn.btn-primary.btn-icon.btn-big(
                    style="padding: 0"
                    @click="addSubDomain",
                    v-show="activeSite.subDomain.length < 6"
                ) 添加其他域名

            .item
                .label
                button.btn.btn-primary.btn-small(@click="onSave") 保存
                //- div.btn.btn-default.btn-medium(@click="hideSiteInfo") 取消

    v-modal(
        :visible="siteInfoVisible",
        :title="siteInfoTitle",
        @closemodal="hideSiteInfo",
        ref="formModal"
    )
        .modal-content(v-if="siteInfoVisible")
            v-form(v-model="activeSite", :before-submit="preventSubmit")
                v-form-item(label="站点名称")
                    v-input(v-model="activeSite.domainTitle", :rules="rules.title", placeholder="请输入1-50字符名称")
                .item
                    .label 站点分类：
                    .control
                        select.industry(
                            :class="{error: industrySelectionsDirty && industryErrors[0]}"
                            v-model="activeSite.industry_1",
                            @change="resetSubIndustry"
                        )
                            option(
                                v-for="item in industryMainList",
                                :value="item.id",
                                :key="item.id"
                            ) {{item.name}}
                        select.sub-industry(
                            v-model="activeSite.industry_2",
                            :class="{error: industrySelectionsDirty && industryErrors[1]}",
                            @change="industrySelectionsDirty = true"
                        )
                            option(
                                v-for="item in industrySubList",
                                :value="item.id",
                                :key="item.id"
                            ) {{item.name}}

                        em.error(v-show="industrySelectionsDirty && (industryErrors[0] || industryErrors[1])") 请选择分类
                .item
                    .label 主域名：
                    .control(v-show="siteInfoStatus === 'edit'", style="float: left; max-width: 400px; word-break: break-word; margin-top: 8px; line-height: 2;")
                        | {{activeSite.domain}}
                        input(type="hidden", v-model="activeSite.domain")
                    .control(v-show="siteInfoStatus === 'new'") 
                        v-input(v-model="activeSite.domain", :rules="rules.domain", @input="onDomainInput", placeholder="请输入域名如aaa.com,300字符以内")

                .item(v-for="(item, index) in activeSite.subDomain", :key="index")
                    .label 域名 {{index + 1}}：
                    .control
                        v-input(
                            v-model="activeSite.subDomain[index]",
                            :rules="rules.subDomain",
                            ref="subdomain",
                            placeholder="请输入域名，不建议输入带path的URL"
                        )
                        a(@click="removeSubDomain(index)") 
                          i.fa.fa-trash
                .item(v-show="activeSite.subDomain.length > 0")
                    .label
                    .control
                      span.note-text （注：添加其他域名需与主域名不同，实现跨域监测数据）
                .item
                    .label
                    .btn.btn-primary.btn-icon.btn-big(
                        style="padding: 0"
                        @click="addSubDomain",
                        v-show="activeSite.subDomain.length < 6"
                    ) 添加其他域名

                .item
                    .label
                    button.btn.btn-primary.btn-small(@click="onSave") 保存
                    div.btn.btn-default.btn-small(@click="hideSiteInfo") 取消

    v-modal(:visible="dialogVisible", title="获取代码", @closemodal="dialogVisible=false; noCopy= false")
        .modal-bd
            .modal-content
                p 请将框内代码复制到您网站所有页面的&lt;/body&gt;前，添加成功后立即开始统计。
                textarea.code-area(cols="80", rows="6", id="jsCodeArea") {{currentJscode || '正在获取中...'}}
                p.clip-note
                    span(v-show="copySuccess") 复制成功，复制内容已经进入您的剪切板，右键“粘贴”即可。
            .btn-wrap(v-show="!noCopy")
                button.btn.btn-primary.btn-medium(
                    ref="jsCopyCode",
                    data-clipboard-action="copy",
                    data-clipboard-target="#jsCodeArea"
               ) 复制代码
    
    v-modal(:visible="deletePopShown", title="确定删除该域名吗？", @closemodal="deletePopShown=false")
        .modal-content
            | 删除后，站点所有历史数据将被清空，且无法恢复。确定删除后，请同时移除您网站上的360统计代码。
        .btn-wrap
            button.btn.btn-primary.btn-small(@click="deleteSite") 确定
            button.btn.btn-default.btn-small(@click="deletePopShown=false") 取消
</template>

<script>
/* global _ */
import Vue from 'vue'
import FlowGrid from './vue-flow-grid.js'
Vue.use(FlowGrid)

const domainRe = /^[0-9a-z]+[0-9a-z.-]*\.[a-z]+$/
/* eslint-disable no-extend-native */
Array.prototype.findAll = Array.prototype.findAll || function (item) {
  return this.filter(i => i === item)
}

export default {
  data () {
    const vm = this
    return {
      noCopy: false,
      isSubmiting: false,
      deletePopShown: false,
      deleteItem: [],
      currentJscode: '',
      copySuccess: false,
      siteInfoStatus: 'new',
      siteInfoVisible: false,
      dialogVisible: false,
      industryInfo: [],
      industryMainList: [],
      list: [],
      industrySelectionsDirty: false,
      activeSite: {
        id: 0,
        domainTitle: '',
        domain: '',
        subDomain: [],
        industry_1: -1,
        industry_2: -1
      },
      rules: {
        title: {
          required: true,
          maxlength: 50,
          msg: {
            required: '请填写此项',
            maxlength: '站点名称过长'
          }
        },
        domain: {
          required: true,
          maxlength: 300,
          pattern: domainRe,
          msg: {
            required: '请填写此项',
            maxlength: '主域名过长',
            pattern: '主域名格式错误'
          }
        },
        subDomain: {
          maxlength: 300,
          pattern: domainRe,
          msg: {
            maxlength: '子域名过长',
            pattern: '子域名格式错误'
          },
          duplicate (value) {
            const val = _.trim(value)
            const subs = _.map(vm.activeSite.subDomain, _.trim)
            let msg = ''
            let valid = false

            if (_.trim(vm.activeSite.domain) === val) {
              msg = '与主域名重复'
            } else if (subs.findAll(value).length > 1) {
              msg = '与其他域名重复'
            } else {
              valid = true
            }

            return { valid, msg }
          }
        }
      }
    }
  },
  computed: {
    industrySubList () {
      const id = this.activeSite.industry_1
      if (id < 0) {
        this.activeSite.industry_2 = -1
        return [{ name: '请选择', id: -1 }]
      }

      const obj = this.industryInfo[id]
      return Object.keys(obj).reduce((accu, id) => {
        accu.push({
          id,
          name: obj[id]
        })
        return accu
      }, [{ name: '请选择', id: -1 }])
    },
    siteInfoTitle () {
      return this.siteInfoStatus === 'new' ? '新建站点' : '编辑站点'
    },
    domainList () {
      return this.$store.state.domainList || []
    },
    industryErrors () {
      return [
        this.activeSite.industry_1 < 0,
        this.activeSite.industry_2 < 0
      ]
    },
    domainRepeated () {
      const subs = this.activeSite.subDomain.slice(0)
      const domain = this.activeSite.domain
      return _.uniqBy(subs, _.trim).length !== subs.length || _.indexOf(subs, domain) > -1
    }
  },
  methods: {
    onDomainInput () {
      _.forEach(this.$refs.subdomain, i => {
        i.validate()
      })
    },

    autoFocusFirstInput () {
      this.$nextTick(() => {
        const input = this.$refs.formModal.$el.querySelector('input[type="text"]')
        input && input.focus()
      })
    },

    calcIndustry ({ industry_1, industry_2 }) {
      if (!industry_1 || !industry_2) return ''
      const sub = this.industryInfo[industry_1][industry_2]
      const main = this.industryInfo[0][industry_1]
      return `${main}-${sub}`
    },
    resetSubIndustry () {
      this.industrySelectionsDirty = true
      this.activeSite.industry_2 = -1
    },
    hideSiteInfo () {
      this.siteInfoVisible = false
      this.resetActiveSite()
    },
    openSiteEdit (item) {
      this.siteInfoStatus = 'edit'
      this.siteInfoVisible = true
      const site = _.cloneDeep(item)
      site.industry_1 = site.industry_1 || -1
      site.industry_2 = site.industry_2 || -1
      this.activeSite = site
      this.industrySelectionsDirty = false
      this.autoFocusFirstInput()
    },
    resetActiveSite () {
      this.activeSite.domain = ''
      this.activeSite.domainTitle = ''
      this.activeSite.id = ''
      this.activeSite.subDomain = []
      this.activeSite.industry_1 = -1
      this.activeSite.industry_2 = -1
      this.industrySelectionsDirty = false
    },
    openSiteNew () {
      if (this.domainList.length >= 100) {
        return this.$Modal.warn('最多只能添加 100 个站点！')
      }
      this.siteInfoStatus = 'new'
      this.siteInfoVisible = true
      this.resetActiveSite()
      this.autoFocusFirstInput()
    },
    addSubDomain () {
      const refs = this.$refs.subdomain
      const allSubsOk = refs ? refs.every(r => r.validity.valid) : true
      const subs = this.activeSite.subDomain
      if (!subs.length || allSubsOk && _.trim(_.last(subs))) {
        this.activeSite.subDomain.push('')
        const modalRef = this.$refs.formModal
        const centerFn = modalRef._centerModal
        this.$nextTick(() => {
          centerFn && modalRef._centerModal()
          _.last(this.$refs.subdomain).$el.querySelector('input').focus()
        })
      } else {
        const last = _.last(refs.filter(r => !r.validity.valid)) || _.last(refs)
        last.$el.querySelector('input').focus()
      }
    },
    removeSubDomain (index) {
      this.activeSite.subDomain.splice(index, 1)
    },

    initDomainInfo () {
      Promise.all([
        this.$http.get('/api/domain/list').then(r => r.data),
        this.$http.get('/api/domain/industry').then(r => r.data)
      ]).then(([domain, industry]) => {
        const industryInfo = industry.data
        const industryMain = industryInfo[0]
        const mainList = Object.keys(industryMain).map(key => {
          return {
            id: key,
            name: industryMain[key]
          }
        })

        this.industryMainList = [{ name: '请选择', id: -1 }].concat(mainList)
        this.industryInfo = industryInfo

        const domainList = domain.list
        _.forEach(domainList, item => {
          item.industryText = this.calcIndustry(item)
        })
        this.$store.commit('SET_DOMAINLIST', { domainList })
      })
    },

    preventSubmit () {
      const activeState = this.activeSite
      const industryInvalid = activeState.industry_1 < 0 || activeState.industry_2 < 0
      if (!industryInvalid && !this.isSubmiting) {
        this.submitSite()
      }
      return false
    },

    onSave () {
      this.industrySelectionsDirty = true
    },

    // 提交新站点或修改
    submitSite () {
      this.isSubmiting = true

      const isEdit = this.siteInfoStatus === 'edit' && this.domainList.length != 0
      const params = _.extend({}, this.activeSite)
      params.subDomain = params.subDomain.filter(s => _.trim(s))
      params.subDomain = JSON.stringify(params.subDomain)
      this.$http.get(`/api/domain/${isEdit ? 'set' : 'add'}`, {
        params: params
      }).then(r => {
        const { errmsg, errno, data } = r.data
        if (errno) {
          return this.$Modal.warn(errmsg)
        }

        const list = this.$store.state.domainList
        let domainList = null

        if (isEdit) {
          const index = _.findIndex(list, { domain: params.domain })
          domainList = _.cloneDeep(list)
          domainList[index] = data
        } else {
          domainList = [data, ...list]
        }

        data.industryText = this.calcIndustry(data)
        data.subDomain = data.subDomain.filter(s => _.trim(s))

        this.$store.commit('SET_DOMAINLIST', { domainList })
        this.$nextTick(() => {
          this.siteInfoVisible = false
          this.resetActiveSite()
          this.$refs.newSite && this.$refs.newSite.resetValidity()
        })
      }).then(() => {
        this.isSubmiting = false
      }).catch(() => {
        this.isSubmiting = false
      })
    },
    openDeleteSite (item, index) {
      this.deletePopShown = true
      this.deleteItem = [item, index]
    },

    deleteSite () {
      const [item, index] = this.deleteItem
      this.$http.get('/api/domain/delete', {
        params: { id: item.id }
      }).then(res => {
        return res.data
      }).then(({ errno, errmsg }) => {
        if (errno) return this.$Modal.warn(errmsg)

        const list = this.$store.state.domainList
        const listNew = _.cloneDeep(list)
        listNew.splice(index, 1)

        // 如果删除的 domain 是当前所在的呢
        // 需要处理一下
        if (Number(item.id) === Number(this.$store.state.domainId)) {
          // 还有剩余的
          if (listNew.length) {
            this.$store.commit('SET_CURRENT_DOMAIN', { domain: listNew[0] })
            this.$store.commit('SET_DOMAINID', { domainId: listNew[0].id })
          }
          // 都删光了
          else {
            this.$store.commit('SET_CURRENT_DOMAIN', { domain: {} })
            this.$store.commit('SET_DOMAINID', { domainId: ''})
          }
        }
        this.$store.commit('SET_DOMAINLIST', { domainList: listNew })
      }).then(() => {
        this.deletePopShown = false
      }).catch(e => {
        this.deletePopShown = false
        this.$Modal.warn('删除失败')
      }).then(() => {
        this.deleteItem = []
      })
    },

    // 剪切板工具初始化
    initClipboard () {
      const clipboard = new Clipboard(this.$refs.jsCopyCode)

      clipboard.on('success', e => {
        this.copySuccess = true
      })

      clipboard.on('error', e => {
        console.error('Action:', e.action)
        console.error('Trigger:', e.trigger)
      })
    },
    openCodePopup (item) {
      this.dialogVisible = true
      this.copySuccess = false
      this.dialogVisible = true
      this.currentJscode = ''
      if (item.jscode) {
        this.currentJscode = item.jscode
        return
      }
      const params = { domainId: item.id }
      this.$http.get('/api/domain/jscode', { params }).then(res => {
        this.currentJscode = item.jscode = res.data.data
        if (_.has(res, 'source' && res.source === 'mv')) {
          this.noCopy = true
        }
      })
    },
    goToReport (id) {
      const domain = _.find(this.$store.state.domainList, { id })
      this.$store.commit('SET_DOMAINID', { domainId: id })
      this.$store.commit('SET_CURRENT_DOMAIN', { domain })
      this.$router.push('/web/overview')
    }
  },
  created () {
    this.initDomainInfo()
  },
  mounted () {
    this.initClipboard()

    const input = this.$refs.newSite.$el.querySelector('input[type="text"]')
    if (this.$store.state.mvAddSite) {
      this.openSiteNew()
      this.activeSite.domain = this.$store.state.currentDomain.domain
      input && input.focus()
    }
    if (!this.domainList.length) {
      input && input.focus()
    }
  },
  destroyed () {
    this.$store.dispatch('SET_MV_ADDSITE', false)
  }
}
</script>
<style scoped>
.industry,
.sub-industry {
    width: 115px;
}
.site-item a:hover,
.site-item a:hover .fa {
    color: #56bf8b;
}
.add-site {
    font-size: 12px;
}
.sites-list .opt {
    margin-top: 0;
    line-height: 50px;
    height: 50px;
    color: #738699
}

.modal .modal-bd .modal-content {
    min-width: 500px;
    overflow: auto;
}

.code-area {
    padding: 10px;
    font-size: 14px;
}
.clip-note {
    font-size: 14px;
}
.note-text {
  margin-top: 15px;
  padding: 0;
  font-size: 12px;
  color: #a3b1bf;
}
.form{ margin-top: 15px}
</style>

<style> 
.sites-list-setting input {
    width: 240px;
}
</style>



// WEBPACK FOOTER //
// sites.vue?50dff7f0